import { render, staticRenderFns } from "./navbar.vue?vue&type=template&id=1508901a"
import script from "./navbar.vue?vue&type=script&lang=ts"
export * from "./navbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VerticalAlert: require('/app/components/VerticalAlert.vue').default,Navbar: require('/app/components/Navbar.vue').default})
